export class XcTeamSummaryModalDataModel {
  openOnPageLoad: boolean = true;
  meetId: number;
  teamId?: number;
  athleteId?: number;
  eventId?: number;

  liveTeamId?: string;
  liveRoundId?: string;

  constructor(
    meetId: number,
    teamId?: number,
    athleteId?: number,
    eventId?: number,
    liveTeamId?: string,
    liveRoundId?: string,
  ) {
    this.meetId = meetId;
    this.teamId = teamId;
    this.athleteId = athleteId;
    this.eventId = eventId;
    this.liveTeamId = liveTeamId;
    this.liveRoundId = liveRoundId;
  }
}
